const CardIcon = () => (
  <svg
    width="27"
    height="24"
    viewBox="0 0 27 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.3512 9.3463V22.0773C26.3512 22.415 26.2171 22.7388 25.9784 22.9776C25.7396 23.2163 25.4158 23.3504 25.0781 23.3504H2.16226C1.82462 23.3504 1.5008 23.2163 1.26204 22.9776C1.02329 22.7388 0.88916 22.415 0.88916 22.0773V9.3463H26.3512ZM26.3512 6.80009H0.88916V1.70767C0.88916 1.37003 1.02329 1.04621 1.26204 0.807454C1.5008 0.5687 1.82462 0.43457 2.16226 0.43457H25.0781C25.4158 0.43457 25.7396 0.5687 25.9784 0.807454C26.2171 1.04621 26.3512 1.37003 26.3512 1.70767V6.80009ZM17.4395 16.9849V19.5311H22.5319V16.9849H17.4395Z"
      fill="white"
    />
  </svg>
);

export default CardIcon;
